export default __webpack_public_path__ + "static/media/racing.fd51e3db.png";